
const account = {
  account: {
    // 1、发送验证码
    testSendSms: `/h5-api-v3/common/open-api/testSendSms`,
    // 2、手机号登录
    testPhoneLogin: `/h5-api-v3/login/open-api/testPhoneLogin`,
  }
}
export default account
